export default __webpack_public_path__ + "static/media/logo.14a47e49.svg";